import { Injectable } from '@angular/core';
import { EventPipelineService } from '@bootstrap/services/event-pipeline.service';
import { Observable } from 'rxjs';
import { map, startWith, shareReplay } from 'rxjs/operators';
import { EventName, PatientAppReady, PatientAppError } from '@itero/itero-client-communication';

/**
 * Patient-card MFE readiness and error state from IteroEventBus.
 *
 * Observables behave like BehaviorSubjects (startWith + shareReplay) to match
 * the contract expected by PatientAppLoadStateService.
 */
@Injectable({ providedIn: 'root' })
export class PatientCardStateService {
	readonly isPatientCardReady$: Observable<boolean> = this.eventPipeline
		.fromEvent<PatientAppReady>(EventName.patientAppReady)
		.pipe(map(() => true), startWith(false), shareReplay(1));

	readonly isPatientCardError$: Observable<boolean> = this.eventPipeline
		.fromEvent<PatientAppError>(EventName.patientAppError)
		.pipe(map(() => true), startWith(false), shareReplay(1));

	constructor(private readonly eventPipeline: EventPipelineService) {}
}
